// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.match-history-head {
  margin-bottom: 3rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/MatchComponents/MatchHistory/MatchHistorySearchContentHeader/index.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF","sourcesContent":[".match-history-head {\n  margin-bottom: 3rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
